<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("timer.menu.settings") }} </template>
        <template #sidebarMain>
            <div>
                <CardToggle :title="$t('shared.general')">
                    <div class="space-y-5">
                        <FormInputDate
                            :title="$t('timer.settings.end_date')"
                            :lang="lang"
                            v-model="timer.endDate"
                            enableTimePicker
                            @valueAsDate="decorateTimerWithEndDate($event, timer)"
                        />
                        <FormSelect
                            v-model="timer.language"
                            :label="$t('timer.settings.label_language')"
                            :options="timerSupportedLanguagesList"
                            :value="timer.language"
                        />
                    </div>
                </CardToggle>
                <CardToggle :title="$t('shared.colors.title')">
                    <div class="space-y-5">
                        <FormInputColor
                            :title="$t('shared.colors.background')"
                            v-model="timer.backColor"
                            :tooltip="$t('shared.select_color_info')"
                        />
                        <FormInputColor
                            :title="$t('shared.colors.text')"
                            v-model="timer.figColor"
                            :tooltip="$t('shared.select_color_info')"
                        />
                        <FormInputColor
                            :title="$t('timer.settings.labels_color')"
                            v-model="timer.labelColor"
                            :tooltip="$t('shared.select_color_info')"
                        />
                    </div>
                </CardToggle>
                <CardToggle :title="$t('shared.styles')">
                    <div class="space-y-5">
                        <FormToggleSm
                            :title="$t('love.styles.transparent_background')"
                            v-model="timer.transparent"
                        />

                        <FormSelect
                            v-if="googleFonts?.length"
                            v-model="timer.fontFamily"
                            :label="$t('shared.font_family')"
                            :options="googleFonts"
                            :value="timer.fontFamily"
                        />
                        <FormInput
                            :title="$t('timer.settings.counter_size')"
                            :placeholder="'96'"
                            v-model="timer.timerSize"
                            :tooltip="$t('shared.change_px_info')"
                        />
                        <FormInput
                            :title="$t('timer.settings.labels_size')"
                            :placeholder="'24'"
                            v-model="timer.labelSize"
                            :tooltip="$t('shared.change_px_info')"
                        />
                    </div>
                </CardToggle>
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { CardToggle } from "@easy/ui/cards";
import { FormInputColor, FormInput, FormSelect, FormToggleSm, FormInputDate } from "@easy/ui/forms";
import { mapState } from "vuex";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useTimerSetup } from "@/apps/timer/project/useTimerSetup";
import { onMounted } from "vue";
import { useActions } from "@/store/vuex-composition-mappers";

export default {
    name: "SidebarSettings",
    components: {
        CardToggle,
        FormInputColor,
        FormInput,
        FormSelect,
        FormToggleSm,
        FormInputDate,
        PageSidebar,
        cSaveButton,
    },
    setup() {
        const { getFonts } = useActions(["getFonts"]);
        const { saveSnapshot } = useActions("timer", ["saveSnapshot"]);
        const { decorateTimerWithEndDate } = useTimerSetup();
        onMounted(async () => {
            await getFonts();
        });
        return { decorateTimerWithEndDate, saveSnapshot };
    },
    data() {
        return {
            timerSupportedLanguagesList: [
                { value: "en", label: "english" },
                { value: "pl", label: "polski" },
                { value: "fr", label: "français" },
                { value: "it", label: "italiano" },
                { value: "de", label: "deutsch" },
                { value: "es", label: "español" },
                { value: "ru", label: "русский" },
                { value: "nl", label: "nederlands" },
                { value: "sl", label: "slovenš" },
                { value: "pt", label: "português" },
            ],
        };
    },
    computed: {
        ...mapState({
            googleFonts: (f) => f.googleFonts.map((label) => ({ label, value: label })),
        }),
        ...mapState(["lang"]),
        ...mapState("timer", ["timer", "hasChanges"]),
    },
};
</script>
